import script from "./LessonProgressBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./LessonProgressBar.vue?vue&type=script&lang=ts&setup=true"

import "./LessonProgressBar.vue?vue&type=style&index=0&id=84053e9c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84053e9c"]])

export default __exports__